import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateVenue($companyId: ID!, $id: ID!, $attributes: VenueAttributes!) {
    updateVenue(companyId: $companyId, id: $id, attributes: $attributes) {
      venue {
        id
        ...UpdatedVenue
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedVenue on Venue {
    id
    name
    address
    address1
    address2
    address3
    city
    county
    postcode
    notes
    map { url }
  }
`
